export const formatCurrency = (number, format = 'no-decimals', separator = ',') => {
  const inString = (format === 'no-decimals' ? Math.round(number) : number).toString()
  const decimals = inString.split('.')[1]
  const integer = inString.split('.')[0]
  const inArray = [...integer]
  let tempChars = []
  let formatedString = ''
  for(let i = inArray.length - 1; i >= 0; i--) {
    const char = inArray[i]
    tempChars.unshift(char)
    if (tempChars.length === 3 || i === 0) {
      let includeSeparator = i > 0
      formatedString = `${includeSeparator ? separator : ''}${tempChars.join('')}${formatedString}`
      tempChars = []
    }
  }
  if (decimals) {
    const decimalsRound = Math.round(parseFloat(decimals.slice(0, 2) + '.' + decimals.slice(2)))
    formatedString = `${formatedString}.${decimalsRound}`
  }
  if (!decimals && format === 'decimals') {
    formatedString = `${formatedString}.00`
  }
  return formatedString
}

export const ensureNumber = (number) => {
  if (typeof number === 'string') {
    let transformedNumber = number
    if (number.includes(',')) {
      transformedNumber = number.replace(/\./, '').replace(/,/, '.')
    }
    return Number(transformedNumber)
  } else {
    return number
  }
}